/**
 * Google Analytics 4 (GA4) Tracking Service
 * Feature: FCAC-516
 */

const getMeasurementId = () => {
    return window?.runConfig?.REACT_APP_GA_MEASUREMENT_ID || window?.REACT_APP_GA_MEASUREMENT_ID || '';
};

/**
 * Khoi tao Google Tag (gtag.js) dong theo Measurement ID tu runtime-config.js
 */
export const initGA = () => {
    try {
        const measurementId = getMeasurementId();
        if (!measurementId || typeof measurementId !== 'string' || !measurementId.startsWith('G-')) {
            return;
        }

        if (document.getElementById('ga4-gtag-script')) {
            return;
        }

        const script = document.createElement('script');
        script.id = 'ga4-gtag-script';
        script.async = true;
        script.src = `https://www.googletagmanager.com/gtag/js?id=${measurementId}`;
        document.head.appendChild(script);

        window.dataLayer = window.dataLayer || [];
        window.gtag = function () {
            window.dataLayer.push(arguments);
        };
        window.gtag('js', new Date());
        window.gtag('config', measurementId, {
            send_page_view: false,
        });
    } catch (e) {
        // Safe fail: khong lam anh huong ung dung neu bi chan boi trinh duyet
    }
};

/**
 * Loc bo cac truong nhay cam PII va gia tri null/undefined
 */
const sanitizeParams = (params = {}) => {
    const forbiddenKeys = ['email', 'phone', 'fullname', 'tax_code', 'citizen_id', 'identity_card', 'password'];
    const clean = {};
    Object.keys(params).forEach((key) => {
        if (params[key] !== undefined && params[key] !== null && !forbiddenKeys.includes(key.toLowerCase())) {
            clean[key] = params[key];
        }
    });
    return clean;
};

/**
 * Ham core gui su kien GA4 phong thu adblocker
 */
export const trackEvent = (eventName, params = {}) => {
    try {
        if (typeof window.gtag === 'function') {
            const cleanParams = sanitizeParams(params);
            window.gtag('event', eventName, cleanParams);
        }
    } catch (e) {
        // Safe fail
    }
};

// 1. Luong Tao & Gui hop dong (Creation Funnel)
export const trackFileUpload = (params) => trackEvent('file_upload', params);
export const trackSelectTemplate = (params) => trackEvent('select_template', params);
export const trackSetupSigners = (params) => trackEvent('setup_signers', params);
export const trackSendContract = (params) => trackEvent('send_contract', params);

// 2. Luong Ky hop dong (Signing Funnel)
export const trackViewDocument = (params) => trackEvent('view_document', params);
export const trackVerifySignerIdentity = (params) => trackEvent('verify_signer_identity', params);
export const trackPlaceSignature = (params) => trackEvent('place_signature', params);
export const trackSelectSignMethod = (params) => trackEvent('select_sign_method', params);
export const trackSignComplete = (params) => trackEvent('sign_complete', params);
export const trackSignReject = (params) => trackEvent('sign_reject', params);

// 3. Tuong tac & Van hanh tai lieu (Operations)
export const trackDownloadContract = (params) => trackEvent('download_contract', params);
export const trackResendSigningReminder = (params) => trackEvent('resend_signing_reminder', params);
export const trackCancelContract = (params) => trackEvent('cancel_contract', params);

// 4. Onboarding & Thiet lap he thong
export const trackTutorialComplete = (params) => trackEvent('tutorial_complete', params);
export const trackProfileUpdate = (params) => trackEvent('profile_update', params);
export const trackConnectSignatureDevice = (params) => trackEvent('connect_signature_device', params);

// 5. Goi cuoc & Ban quyen (Billing)
export const trackViewPricing = (params) => trackEvent('view_pricing', params);
export const trackUpgradePackage = (params) => trackEvent('upgrade_package', params);

// 6. Phe duyet noi bo (Internal Approval)
export const trackApproveContract = (params) => trackEvent('approve_contract', params);
export const trackRejectApproval = (params) => trackEvent('reject_approval', params);
export const trackDelegateSigning = (params) => trackEvent('delegate_signing', params);

// 7. Tim kiem & Loc & Xuat bao cao (Search & Filters & Reports)
export const trackSearchContract = (params) => trackEvent('search_contract', params);
export const trackFilterContract = (params) => trackEvent('filter_contract', params);
export const trackExportReport = (params) => trackEvent('export_report', params);

// 8. Ky theo lo & Ky nhanh (Batch & Quick Signing)
export const trackBatchSendContract = (params) => trackEvent('batch_send_contract', params);
export const trackBatchSignComplete = (params) => trackEvent('batch_sign_complete', params);
export const trackQuickSignComplete = (params) => trackEvent('quick_sign_complete', params);

// 9. Mau & Cau hinh chu ky & Doi tac (Templates, Stamps & Partners)
export const trackCreateCustomTemplate = (params) => trackEvent('create_custom_template', params);
export const trackSaveSignatureStamp = (params) => trackEvent('save_signature_stamp', params);
export const trackAddPartner = (params) => trackEvent('add_partner', params);

// 10. Tai lieu ca nhan (Personal Documents)
export const trackUploadPersonalDoc = (params) => trackEvent('upload_personal_doc', params);
export const trackSignPersonalDoc = (params) => trackEvent('sign_personal_doc', params);

// 11. Dieu huong SPA (Pageview Navigation - Phase 3)
export const trackPageView = (path) =>
    trackEvent('page_view', {
        page_path: path,
        page_title: document.title,
    });

// 12. Quan tri Nguoi dung & Vai tro (Users & Roles - Phase 3)
export const trackManageUser = (params) => trackEvent('manage_user', params);
export const trackManageRole = (params) => trackEvent('manage_role', params);

// 13. Cau hinh Chung thu so (Certificate Configuration - Phase 3)
export const trackConfigureCertificate = (params) => trackEvent('configure_certificate', params);

// 14. Tuong tac Dashboard & Thong ke (Dashboard Interactions - Phase 3)
export const trackViewDashboard = (params) => trackEvent('view_dashboard', params);
export const trackFilterDashboard = (params) => trackEvent('filter_dashboard', params);
